export default __webpack_public_path__ + "static/media/solidity.6b7f09b8.png";